<template>
  <div ref="container" class="text-omission">
    <span ref="filename" class="filename" :title="fileName">
      {{ newFileName ? newFileName : fileName }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'TextOmission',
  props: {
    // 文件名
    fileName: {
      type: String,
      required: true,
      default: '',
    },
  },
  data() {
    return {
      newFileName: null,
    };
  },

  watch: {
    // 监听文件名
    fileName: {
      handler() {
        this.newFileName = this.truncatedFileName();
      },
    },
  },

  mounted() {
    this.newFileName = this.truncatedFileName();
  },

  methods: {
    truncatedFileName() {
      const containerDom = this.$refs.container; // 获取容器dom
      const filenameDom = this.$refs.filename; // 获取文件名dom
      const containerWidth = containerDom.offsetWidth; // 获取容器宽度
      const filenameWidth = filenameDom.offsetWidth; // 获取文件名宽度

      if (filenameWidth >= containerWidth) {
        // 计算需要截断的字符数
        const availableWidth = containerWidth - 30; // 留出一些空间用于省略号
        const averageCharWidth = filenameWidth / this.fileName.length;
        const truncateChars = Math.floor((filenameWidth - availableWidth) / averageCharWidth);

        // 截断文件名中间部分
        const start = Math.ceil((this.fileName.length - truncateChars) / 2);
        const end = this.fileName.length - Math.floor((this.fileName.length - truncateChars) / 2);

        const truncatedFileName =
          this.fileName.substring(0, start) +
          '...' +
          this.fileName.substring(end, this.fileName.length);

        return truncatedFileName;
      }
      return this.fileName;
    },
  },
};
</script>

<style>
.text-omission {
  width: 100%; /* 设置容器宽度 */
  white-space: nowrap; /* 防止文件名换行 */
  overflow: hidden; /* 隐藏溢出部分 */
  text-overflow: ellipsis; /* 使用省略号表示截断的文本 */
}

.filename {
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/TextOmission/index.vue